define('app/sf/debugger/sf-debugger-filter',[],function () {
	return function debuggerFilter(input) {
		arguments;
		debugger;
		return input;
	};
});
